<template>
  <div ref="modaldes" class="modal" tabindex="-1" role="dialog" id="modal-nliquidacioncar">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title text-center"><b>Liquidacion</b></h5>
        </div>

        <div class="modal-body" v-if="ins && ins.estudiante">
          <p class="mb-0">
            <b>Estudiante:</b> {{ ins.estudiante.nombres }} {{ ins.estudiante.pri_apellido }}
            {{ ins.estudiante.seg_apellido }}
          </p>
          <p><b>Asesor:</b> {{ ins.asesor.nombres }} {{ ins.asesor.pri_apellido }} {{ ins.asesor.seg_apellido }}</p>

          <v-progress-linear v-if="loading" indeterminate height="2" class="ma-0 pa-0" />

          <p class="mb-0 mt-4"><span class="text-danger">*</span> Motivo de liquidacion</p>
          <div>
            <select class="form-control" v-model="motivo">
              <option v-for="(m, ind) in motivos" :key="ind" :value="m"> {{ m.descripcion }} </option>
            </select>
          </div>

          <p class="mb-0 mt-4"><span class="text-danger">*</span> Descripcion de la liquidacion</p>
          <div>
            <textarea
              class="form-control"
              v-model.trim="descripcion"
              rows="4"
              placeholder="Ingrese una descripcion de la liquidacion..."
            >
            </textarea>
          </div>

          <v-container v-show="false">
            <v-row>
              <v-col cols="12" class="ma-0 pa-0 mt-2">
                <v-text-field
                  label="Lugar*"
                  outlined
                  dense
                  color="#980000"
                  single-line
                  solo
                  counter
                  prepend-inner-icon="mdi-city"
                  hint="Monto de descuento"
                  maxLength="50"
                  vv-model.trim="lugar"
                  persistent-hint
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="ma-0 pa-0 mt-2">
                <v-text-field
                  label="Carnet*"
                  outlined
                  dense
                  color="#980000"
                  single-line
                  solo
                  counter
                  prepend-inner-icon="mdi-account-box"
                  hint="Carnet de identidad"
                  maxLength="20"
                  vv-model.trim="carnet"
                  persistent-hint
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="ma-0 pa-0 mt-2">
                <v-text-field
                  label="Correo*"
                  outlined
                  dense
                  color="#980000"
                  single-line
                  solo
                  counter
                  prepend-inner-icon="mdi-email"
                  hint="Correo electronico"
                  maxLength="45"
                  vv-model.trim="email"
                  persistent-hint
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="ma-0 pa-0 mt-2">
                <v-text-field
                  label="Telefono*"
                  outlined
                  dense
                  color="#980000"
                  single-line
                  solo
                  counter
                  prepend-inner-icon="mdi-phone"
                  hint="Telefono o celular"
                  maxLength="12"
                  vv-model.trim="telefono"
                  persistent-hint
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>

          <p class="text-center text-danger">
            <b>{{ msg }}</b>
          </p>
          <div class="text-center">
            <div style="display: inline-block;" v-show="loading" class="loader"></div>
          </div>

          <div class="xcard">
            <b class="blue--text">
              Escriba: <span class="red--text">{{ estado }}</span> para proceder con la liquidacion.
            </b>
            <input type="text" class="form-control" v-model="proceder_text" />

            <div class="text-right mt-1">
              <button
                @click="validar()"
                :disabled="loading || exitoso || !proceder_text || proceder_text != estado"
                type="button"
                class="btn btn-azul white--text mr-2"
              >
                Liquidar
              </button>
              <button type="button" class="btn btn-secondary black--text" data-dismiss="modal">Cerrar</button>
            </div>
          </div>
        </div>

        <!-- <div class="modal-footer">
                    <button @click="validar()" :disabled="loading || exitoso" type="button" class="btn btn-azul white--text">Solicitar</button>
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
                </div> -->
      </div>
    </div>
  </div>
</template>

<script>
  import xaxios from '@/xaxios';
  export default {
    props: { ins: { type: Object, required: true } },
    data() {
      return {
        motivos: [],
        descuentostipos: [],
        xins: {},
        xprograma: {},
        msg: '',
        loading: false,

        motivo: {},
        inscripcion_id: null,
        descripcion: '',
        exitoso: false,
        estado: 'liquidar',
        proceder_text: '',
      };
    },
    watch: {},
    components: {},
    methods: {
      getdescuentostipo(ins, programita) {
        window.console.log("descuentos tipos....", programita);
        this.xprograma = programita;
        this.msg = '';
        this.motivo = {};
        this.exitoso = false;
        this.descripcion = '';
        this.proceder_text = '';
        this.xins = ins;
        this.inscripcion_id = ins.id;
        this.motivos = [];
        this.loading = true;
        const vue = this;
        let unidad = vue.$store.state.CARGO.sede.unidad_negocio;
        let id_inscripcion = ins.id;
        const urlm = `${process.env.VUE_APP_API_REST}/api/v1/motivos?descuento_tipo_id=3&unidad_negocio_id=${unidad}`; // el 3 solo lista los motivos de liquidacion
        const urld = `${process.env.VUE_APP_API_REST}/api/v1/descuento-tipos`;
        const urlc =
          `${process.env.VUE_APP_API_REST}/api/v1/inscripcion/concepto_pagos?acepta_descuento=true&inscripcion_id=` +
          id_inscripcion;
        const urlp = `${process.env.VUE_APP_API_REST}/api/v1/inscripcion/${id_inscripcion}/plan-pago`;
        const promise1 = xaxios.get(urlm);
        const promise2 = xaxios.get(urld);
        const promise3 = xaxios.get(urlc);
        const promise4 = xaxios.get(urlp);

        Promise.all([promise1, promise2, promise3, promise4]).then(function(values) {
          let data0 = values[0];
          let data1 = values[1];
          if (data0.data == '') data0 = { data: { data: [] } };
          if (data1.data == '') data1 = { data: { data: [] } };
          window.console.log(data0, data1, unidad);

          data1.data.data.forEach((x) => {
            vue.descuentostipos.push(x);
          });
          data0.data.data.forEach((x) => {
            let tipodes = vue.descuentostipos.find((t) => t.id == x.descuento_tipo);
            x.xtipodes = tipodes;
            vue.motivos.push(x);
          });
          vue.loading = false;
        });
      },
      validar() {
        this.msg = '';
        if (!this.inscripcion_id) {
          this.msg = 'Inscripcion no encontrada';
          return;
        }
        if (!this.motivo.id) {
          this.msg = 'Seleccione un motivo.';
          return;
        }
        if (!this.descripcion) {
          this.msg = 'Escriba una descripcion para soliciatr el descuento';
          return;
        }

        let data = {
          descripcion: this.descripcion,
          inscripcion_id: this.inscripcion_id,
          motivo_id: this.motivo.id,
        };

        window.console.log(data);
        this.enviar(data);
      },
      enviar(datos) {
        const vue = this;
        vue.loading = true;
        const url = `${process.env.VUE_APP_API_REST}/api/v1/inscripcion/pagos/liquidacion`;
        xaxios
          .post(url, datos)
          .then((res) => {
            window.console.log(res);
            vue.msg = res.data.data;
            vue.loading = false;
            vue.exitoso = true;
            vue.$emit('onliquidado', datos);
          })
          .catch((error) => {
            window.console.error(error, error.response);
            vue.msg = error.response.data.data;
            vue.loading = false;
          });
      },
    },
    mounted() {
      var vue = this;
      window.$('#modal-nliquidacioncar').on('hide', function() {
        vue.msg = '';
        vue.motivo = {};
        vue.monto = null;
        vue.inscripcion_id = null;
        vue.descripcion = '';
      });
    },
  };
</script>
